import * as Sentry from "@sentry/nextjs";

export async function fetchPrice() {
  try {
    const response = await fetch("/api/price?currency=rub");
    const data = await response.json();
    if (response.ok) {
      return data.price;
    } else {
      Sentry.captureException(`Ошибка при получении цены`);
    }
  } catch (error) {
    Sentry.captureException(`Ошибка при получении цены: ${error}`);
    return null;
  }
}
